module.exports = __webpack_public_path__ + "img/mstile-310x310.bd5db5d7.png";